// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const res = await fetch("/firebase-config.json");
const firebaseConfig = await res.json();

const VAPID_KEY = 'BMiOQsPPVpTZFESA3c6DZ2pJqAhzmTOgrsAP-yDgPfrktudcx9QNDPeM55BpzXUPfK62JBtBp2Ly8bRs2Y4YmD4';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

export { app, analytics, messaging , VAPID_KEY};